import '@modules/product-card-quick-add/product-card-quick-add.js';

class ProductRecommendations extends HTMLElement {
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');
          if (recommendations && recommendations.innerHTML.trim().length > 0) {
            this.innerHTML = recommendations.innerHTML;

            const productCardRows = this.querySelectorAll(
              '[data-product-card-row]'
            );
            for (const productCardRow of productCardRows) {
              const productCardQuickAdd = productCardRow.querySelector(
                'product-card-quick-add'
              );

              if (!productCardQuickAdd) continue;
              productCardQuickAdd.addToCart();
            }
          }
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.error(error);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: '0px 0px 400px 0px'
    }).observe(this);
  }
}

customElements.get('product-recommendations') ||
  customElements.define('product-recommendations', ProductRecommendations);
